import { SeverityLevels } from '../../types/SeverityLevels';
export const definePinoLogHandlers = handlers => message => {
  switch (message.level) {
    case SeverityLevels.INFO:
      handlers.onInfo?.(message);
      break;
    case SeverityLevels.METRIC:
      handlers.onMetric?.(message);
      break;
    case SeverityLevels.ERROR:
      handlers.onError?.(message);
      break;
    case SeverityLevels.WARN:
      handlers.onWarn?.(message);
      break;
    case SeverityLevels.DEBUG:
      handlers.onDebug?.(message);
      break;
    default:
      // eslint-disable-next-line no-console -- it's okay here
      console.warn(`Unknown message level: ${message.level}`);
  }
};
//# sourceMappingURL=definePinoLogHandlers.js.map